import { MAX_FILE_SIZE, FILE_UPLOAD_REGEX } from './upload-constants';

export interface FileValidationResult {
  showFileSizeError: boolean;
  showFileFormatError: boolean;
}

/**
 * Validates an uploaded file and returns error flags
 */
export function validateUploadFile(file: File): FileValidationResult {
  return {
    showFileSizeError: file.size > MAX_FILE_SIZE,
    showFileFormatError: !FILE_UPLOAD_REGEX.test(file.type),
  };
}
